import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=c3c0f5c0&scoped=true&"
import script from "./BankCard.vue?vue&type=script&lang=js&"
export * from "./BankCard.vue?vue&type=script&lang=js&"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=c3c0f5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c0f5c0",
  null
  
)

export default component.exports